import { Box, Flex, GridItem, Skeleton, SkeletonCircle, SkeletonText, useBreakpointValue } from "@chakra-ui/react";
import { FC } from "react";
import { TeamUserListingItemGrid } from "./teamUserListingItemGrid";
import { v4 as uuid } from "uuid";

export const SkeletonTeamUserListingItem: FC = () => {
  const isMobile = useBreakpointValue([true, false]);

  return (
    <Box
      key={uuid()}
      w={"100%"}
      layerStyle={["with-box-shadow-light", "with-clickable-hover"]}
      borderRadius={"md"}
      pr={[3, 4]}
      pl={[3, 4]}
      pt={3}
      pb={3}
      bgColor={"bg.50"}
    >
      <TeamUserListingItemGrid>
        <GridItem rowSpan={[2, 1]} colSpan={1}>
          <SkeletonCircle size={"36px"} />
        </GridItem>
        <GridItem rowSpan={1}>
          <Flex flexDirection="column" alignItems={['center', 'center', 'flex-start']} gridGap="2px">
            {isMobile ? <SkeletonText noOfLines={1} width="150px" /> : <Skeleton noOfLines={1} height='20px' width="150px" />}
            <SkeletonText noOfLines={1} width="100px" />
          </Flex>
        </GridItem>
        <GridItem>
          <Skeleton height={"32px"} width={"100px"} />
        </GridItem>
      </TeamUserListingItemGrid>
    </Box>
  )
}
